import React from "react";
import { LockKey, ShieldCheck, Package, ArrowsClockwise, Certificate, Truck } from "@phosphor-icons/react";

/**
 * Beefy 6-item trust bar for the Checkout page.
 * Answers the "is this safe?" question BEFORE the customer enters card details.
 */
export default function TrustBar() {
  const items = [
    {
      Icon: LockKey,
      title: "256-bit SSL",
      body: "Your details are encrypted end-to-end.",
      color: "#00FFC2",
    },
    {
      Icon: ShieldCheck,
      title: "PayFast Secure",
      body: "PCI-DSS Level 1 · Same tech as major SA banks.",
      color: "#00FFC2",
    },
    {
      Icon: Certificate,
      title: "100% Authentic",
      body: "Every unit sourced direct from brand.",
      color: "#FFC900",
    },
    {
      Icon: Truck,
      title: "48-72hr Delivery",
      body: "Nationwide dispatch, 2-3 business days.",
      color: "#FF5A1F",
    },
    {
      Icon: Package,
      title: "Discreet Box",
      body: "Plain, unbranded packaging.",
      color: "#8B5CF6",
    },
    {
      Icon: ArrowsClockwise,
      title: "30-day Returns",
      body: "Sealed stock only. Hassle-free.",
      color: "#00FFC2",
    },
  ];

  return (
    <div className="border border-white/10 bg-[#0d0d0d]" data-testid="trust-bar">
      <div className="flex items-center gap-2 border-b border-white/10 px-4 py-2.5">
        <LockKey size={12} weight="fill" className="text-[#00FFC2]" />
        <span className="font-label text-[10px] tracking-widest text-white/70">
          SECURE CHECKOUT · SSL ENCRYPTED
        </span>
      </div>
      <div className="grid grid-cols-2 gap-px bg-white/5 sm:grid-cols-3">
        {items.map(({ Icon, title, body, color }) => (
          <div key={title} className="bg-[#0d0d0d] p-3 sm:p-4">
            <Icon size={18} weight="duotone" color={color} />
            <div className="mt-2 font-display text-[13px] font-bold leading-tight">{title}</div>
            <div className="mt-0.5 text-[10px] text-white/50 leading-snug">{body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
